import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import {
  PrimaryButton,
} from '../../components';
import config from '../../config';
import css from './ContactForm.module.css';
import ReCAPTCHA from 'react-google-recaptcha';

// The SuccessMessage replaces the form if the API successfully returns
const SuccessMessage = () => (
  <p className={css.successMessage}>
    Thank you for your message.<br></br>
    One of the team will get back to you as soon as possible.
  </p>
);

class ContactForm extends Component {
  constructor(props) {
    super(props);
    const {
      submitted = false,
    } = props;

    this.state = {
      submitError: false,
      isLoading: false,
      isSubmitted: submitted,
      recaptchaValue: null,
    };

    this.recaptchaRef = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onRecaptchaChange = this.onRecaptchaChange.bind(this);
  }

  onRecaptchaChange(value) {
    this.setState({ recaptchaValue: value });
  }

  async handleSubmit(e) {
    e.preventDefault();

    // Get form data
    const formData = new FormData(e.target);
    const firstname = formData.get('firstname');
    const lastname = formData.get('lastname');
    const email = formData.get('email');
    const description = formData.get('description');
    const emailoptin = formData.get('emailoptin') === '1';
    const recaptchaToken = this.state.recaptchaValue;

    // Validate required fields
    if (!lastname || !description) {
      this.setState({
        submitError: true,
        contactError: 'Please fill in all required fields (Last Name and Summary)',
      });
      return;
    }

    if (!recaptchaToken) {
      this.setState({
        submitError: true,
        contactError: 'Please complete the reCAPTCHA verification',
      });
      return;
    }

    this.setState({ isLoading: true, submitError: false, contactError: '' });

    try {
      const response = await fetch('/api/send-contact-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstname,
          lastname,
          email,
          description,
          emailoptin,
          recaptchaToken,
        }),
      });

      // Check if response is JSON before parsing
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned an invalid response. Please try again.');
      }

      const result = await response.json();

      if (response.ok && result.success) {
        this.setState({
          isSubmitted: true,
          isLoading: false,
        });
      } else {
        throw new Error(result.error || 'Failed to send contact form submission');
      }
    } catch (error) {
      console.error('Error submitting contact form submission:', error);
      this.setState({
        submitError: true,
        isLoading: false,
        contactError: error.message || 'Failed to send contact form submission. Please try again.',
      });

      // Reset reCAPTCHA on error
      if (this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
        this.setState({ recaptchaValue: null });
      }
    }
  }

  render() {
    const { submitError, contactError, isLoading, isSubmitted } = this.state;
    const {
      userFirstName = null,
      userLastName = null,
      userEmail = null,
    } = this.props;

    if (isSubmitted) {
      return (
        <div role="alert" aria-live="polite" aria-atomic="true">
          <SuccessMessage />
        </div>
      );
    } else {
      return (
        <form onSubmit={this.handleSubmit}>
          {submitError && contactError && (
            <p className={css.errorMessage}>{contactError}</p>
          )}

          <label htmlFor="firstname">First Name</label>
          <input
            id="firstname"
            name="firstname"
            defaultValue={userFirstName}
            disabled={isLoading}
          />

          <label htmlFor="lastname">Last Name *</label>
          <input
            id="lastname"
            name="lastname"
            defaultValue={userLastName}
            required
            disabled={isLoading}
          />

          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            defaultValue={userEmail}
            disabled={isLoading}
          />

          <label htmlFor="emailoptin">Email Opt In</label>
          <input
            type="checkbox"
            value="1"
            name="emailoptin"
            id="emailoptin"
            disabled={isLoading}
          />

          <label htmlFor="description">Summary *</label>
          <textarea
            name="description"
            id="description"
            required
            disabled={isLoading}
          ></textarea>

          <ReCAPTCHA
            ref={this.recaptchaRef}
            sitekey={config.recaptchaSiteKey}
            onChange={this.onRecaptchaChange}
          />

          <PrimaryButton
            type="submit"
            disabled={isLoading}
            inProgress={isLoading}
          >
            <FormattedMessage id="ContactForm.sendFeedback" />
          </PrimaryButton>
        </form>
      );
    }
  }
}

export default ContactForm;
